import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "flex h-full min-h-[420px] flex-col gap-3"
};
const _hoisted_2 = {
  class: "rounded-lg border border-slate-200 bg-white p-3"
};
const _hoisted_3 = {
  class: "flex flex-wrap items-center justify-between gap-3"
};
const _hoisted_4 = {
  class: "min-w-0"
};
const _hoisted_5 = {
  class: "mt-0.5 text-xs text-slate-500"
};
const _hoisted_6 = {
  class: "flex w-full flex-wrap gap-2 sm:w-auto sm:justify-end"
};
const _hoisted_7 = ["disabled"];
const _hoisted_8 = ["disabled"];
const _hoisted_9 = ["disabled"];
const _hoisted_10 = {
  key: 0,
  class: "data-table-empty is-compact bg-white"
};
const _hoisted_11 = {
  key: 1,
  class: "min-h-[420px] flex-1 overflow-hidden rounded-lg border border-slate-200 bg-white"
};
const _hoisted_12 = {
  class: "min-w-full w-max border-l border-t border-slate-200"
};
const _hoisted_13 = {
  class: "sticky top-0 z-10"
};
const _hoisted_14 = {
  class: "flex items-start justify-between gap-2"
};
const _hoisted_15 = {
  class: "min-w-0 flex-1"
};
const _hoisted_16 = {
  class: "truncate text-sm font-semibold text-slate-900"
};
const _hoisted_17 = {
  class: "mt-1.5 flex flex-wrap items-baseline gap-x-2 gap-y-1"
};
const _hoisted_18 = {
  class: "text-sm font-semibold text-slate-700"
};
const _hoisted_19 = {
  class: "text-sm font-semibold text-blue-700"
};
const _hoisted_20 = {
  class: "flex shrink-0 gap-1"
};
const _hoisted_21 = ["disabled", "onClick"];
const _hoisted_22 = ["disabled", "onClick"];
const _hoisted_23 = ["disabled", "onClick"];
const _hoisted_24 = ["disabled", "onClick"];
import { computed, ref } from 'vue';
import { ElMessage } from 'element-plus';
import { ArrowDownIcon, ArrowUpIcon, ArrowsUpDownIcon, CheckCircleIcon, PencilSquareIcon, PlusIcon, TrashIcon } from '@heroicons/vue/24/outline';
import { buildRegionMatrixRows, formatWanAmount, invoiceDropMovePayload, invoiceRegionTotalAmount } from '../utils';
import InvoiceMatrixCustomerCell from './InvoiceMatrixCustomerCell.vue';
import { useWheelToHorizontalScroll } from '../composables/useWheelToHorizontalScroll';
export default {
  __name: 'InvoiceRegionListEditor',
  props: {
    plan: {
      type: Object,
      default: null
    },
    regions: {
      type: Array,
      default: () => []
    },
    customers: {
      type: Array,
      default: () => []
    },
    customersByRegion: {
      type: Object,
      default: () => new Map()
    },
    downstreamAllocations: {
      type: Array,
      default: () => []
    },
    downstreamTagPreferences: {
      type: Array,
      default: () => []
    },
    syncing: {
      type: Boolean,
      default: false
    }
  },
  emits: ['create-region', 'rename-region', 'delete-region', 'reorder-regions', 'sort-regions-by-amount', 'create-customer', 'edit-customer', 'move-customer', 'delete-customer', 'confirm-list'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const matrixScrollRef = useWheelToHorizontalScroll();
    const gridStyle = computed(() => ({
      gridTemplateColumns: `repeat(${Math.max(props.regions.length, 1)}, minmax(192px, 1fr))`
    }));
    const matrixRows = computed(() => buildRegionMatrixRows(props.regions, props.customers, 4));
    const draggedCustomer = ref(null);
    const regionAccentClasses = ['border-t-2 border-t-blue-400', 'border-t-2 border-t-emerald-400', 'border-t-2 border-t-amber-400', 'border-t-2 border-t-violet-400', 'border-t-2 border-t-rose-400', 'border-t-2 border-t-cyan-400'];
    function regionAccentClass(index) {
      return regionAccentClasses[index % regionAccentClasses.length];
    }
    function regionCustomers(regionId) {
      if (props.customersByRegion instanceof Map) return props.customersByRegion.get(regionId) || [];
      return props.customersByRegion?.[regionId] || [];
    }
    function moveRegion(index, offset) {
      const nextIndex = index + offset;
      if (nextIndex < 0 || nextIndex >= props.regions.length) return;
      const nextRegions = [...props.regions];
      const current = nextRegions[index];
      nextRegions[index] = nextRegions[nextIndex];
      nextRegions[nextIndex] = current;
      emit('reorder-regions', nextRegions);
    }
    function requestDeleteRegion(region) {
      if (regionCustomers(region.id).length > 0) {
        ElMessage.warning('名单区域下存在客户，不能删除');
        return;
      }
      emit('delete-region', region);
    }
    function handleCustomerDragStart(payload) {
      draggedCustomer.value = payload?.customer || null;
    }
    function handleCustomerDragLeave() {}
    function handleCustomerDragEnd() {
      draggedCustomer.value = null;
    }
    function handleCustomerDrop(payload) {
      const source = draggedCustomer.value;
      const targetRegionId = payload?.region?.id;
      if (!source?.id || !targetRegionId) {
        draggedCustomer.value = null;
        return;
      }
      const movePayload = invoiceDropMovePayload({
        sourceCustomer: source,
        targetRegionId,
        targetCustomers: regionCustomers(targetRegionId),
        droppedCustomer: payload.customer,
        position: payload.position,
        rowIndex: payload.rowIndex
      });
      if (!movePayload) {
        draggedCustomer.value = null;
        return;
      }
      emit('move-customer', movePayload);
      draggedCustomer.value = null;
    }
    return (_ctx, _cache) => {
      const _directive_permission = _resolveDirective("permission");
      return _openBlock(), _createElementBlock("section", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_cache[6] || (_cache[6] = _createElementVNode("h3", {
        class: "text-sm font-semibold text-slate-900"
      }, "月度客户名单", -1)), _createElementVNode("p", _hoisted_5, _toDisplayString(__props.plan?.planMonth || '-') + " · " + _toDisplayString(__props.regions.length) + " 个区域 · " + _toDisplayString(__props.customers.length) + " 个客户 ", 1)]), _createElementVNode("div", _hoisted_6, [_withDirectives((_openBlock(), _createElementBlock("button", {
        type: "button",
        class: "btn-secondary inline-flex items-center gap-1.5",
        disabled: __props.syncing,
        onClick: _cache[0] || (_cache[0] = $event => emit('create-region'))
      }, [_createVNode(_unref(PlusIcon), {
        class: "h-4 w-4"
      }), _cache[7] || (_cache[7] = _createTextVNode(" 新增区域 ", -1))], 8, _hoisted_7)), [[_directive_permission, 'enterprise-invoice:region:manage']]), _withDirectives((_openBlock(), _createElementBlock("button", {
        type: "button",
        class: "btn-secondary inline-flex items-center gap-1.5",
        disabled: __props.syncing || __props.regions.length < 2,
        onClick: _cache[1] || (_cache[1] = $event => emit('sort-regions-by-amount'))
      }, [_createVNode(_unref(ArrowsUpDownIcon), {
        class: "h-4 w-4"
      }), _cache[8] || (_cache[8] = _createTextVNode(" 按金额排序 ", -1))], 8, _hoisted_8)), [[_directive_permission, 'enterprise-invoice:region:manage']]), _withDirectives((_openBlock(), _createElementBlock("button", {
        type: "button",
        class: "btn-primary inline-flex items-center gap-1.5",
        disabled: __props.syncing || __props.regions.length === 0,
        onClick: _cache[2] || (_cache[2] = $event => emit('confirm-list'))
      }, [_createVNode(_unref(CheckCircleIcon), {
        class: "h-4 w-4"
      }), _cache[9] || (_cache[9] = _createTextVNode(" 确认名单 ", -1))], 8, _hoisted_9)), [[_directive_permission, 'enterprise-invoice:list:confirm']])])])]), __props.regions.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_10, " 暂无名单区域，点击右上角“新增区域”开始 ")) : (_openBlock(), _createElementBlock("div", _hoisted_11, [_createElementVNode("div", {
        ref_key: "matrixScrollRef",
        ref: matrixScrollRef,
        class: "h-full overflow-auto"
      }, [_createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createElementVNode("div", {
        class: "grid",
        style: _normalizeStyle(gridStyle.value)
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.regions, (region, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: region.id,
          class: _normalizeClass(['min-h-[88px] border-r border-b border-slate-200 bg-slate-50 px-3 py-2.5', regionAccentClass(index)])
        }, [_createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, _toDisplayString(region.regionName || '未命名区域'), 1), _createElementVNode("div", _hoisted_17, [_cache[10] || (_cache[10] = _createElementVNode("span", {
          class: "text-[11px] uppercase tracking-wide text-slate-400"
        }, "客户", -1)), _createElementVNode("span", _hoisted_18, _toDisplayString(regionCustomers(region.id).length), 1), _cache[11] || (_cache[11] = _createElementVNode("span", {
          class: "text-[11px] uppercase tracking-wide text-slate-400"
        }, "合计", -1)), _createElementVNode("span", _hoisted_19, _toDisplayString(_unref(formatWanAmount)(_unref(invoiceRegionTotalAmount)(region.id, __props.customers))), 1)])]), _createElementVNode("div", _hoisted_20, [_withDirectives((_openBlock(), _createElementBlock("button", {
          type: "button",
          class: "table-action-button is-neutral",
          title: "上移",
          "aria-label": "上移",
          disabled: __props.syncing || index === 0,
          onClick: $event => moveRegion(index, -1)
        }, [_createVNode(_unref(ArrowUpIcon), {
          class: "h-3.5 w-3.5"
        })], 8, _hoisted_21)), [[_directive_permission, 'enterprise-invoice:region:manage']]), _withDirectives((_openBlock(), _createElementBlock("button", {
          type: "button",
          class: "table-action-button is-neutral",
          title: "下移",
          "aria-label": "下移",
          disabled: __props.syncing || index === __props.regions.length - 1,
          onClick: $event => moveRegion(index, 1)
        }, [_createVNode(_unref(ArrowDownIcon), {
          class: "h-3.5 w-3.5"
        })], 8, _hoisted_22)), [[_directive_permission, 'enterprise-invoice:region:manage']]), _withDirectives((_openBlock(), _createElementBlock("button", {
          type: "button",
          class: "table-action-button is-primary",
          title: "重命名",
          "aria-label": "重命名",
          disabled: __props.syncing,
          onClick: $event => emit('rename-region', region)
        }, [_createVNode(_unref(PencilSquareIcon), {
          class: "h-3.5 w-3.5"
        })], 8, _hoisted_23)), [[_directive_permission, 'enterprise-invoice:region:manage']]), _withDirectives((_openBlock(), _createElementBlock("button", {
          type: "button",
          class: "table-action-button is-danger",
          title: "删除",
          "aria-label": "删除",
          disabled: __props.syncing,
          onClick: $event => requestDeleteRegion(region)
        }, [_createVNode(_unref(TrashIcon), {
          class: "h-3.5 w-3.5"
        })], 8, _hoisted_24)), [[_directive_permission, 'enterprise-invoice:region:manage']])])])], 2);
      }), 128))], 4)]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(matrixRows.value, row => {
        return _openBlock(), _createElementBlock("div", {
          key: row.rowIndex,
          class: "grid",
          style: _normalizeStyle(gridStyle.value)
        }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.cells, cell => {
          return _openBlock(), _createBlock(InvoiceMatrixCustomerCell, {
            key: cell.key,
            region: cell.region,
            regions: __props.regions,
            customer: cell.customer,
            "row-index": cell.rowIndex,
            "dragging-customer-id": draggedCustomer.value?.id,
            "downstream-allocations": __props.downstreamAllocations,
            "downstream-tag-preferences": __props.downstreamTagPreferences,
            syncing: __props.syncing,
            onCreateCustomer: _cache[3] || (_cache[3] = $event => emit('create-customer', $event)),
            onEditCustomer: _cache[4] || (_cache[4] = $event => emit('edit-customer', $event)),
            onDelete: _cache[5] || (_cache[5] = $event => emit('delete-customer', $event)),
            onDragStart: handleCustomerDragStart,
            onDragLeave: handleCustomerDragLeave,
            onDropCustomer: handleCustomerDrop,
            onDragEnd: handleCustomerDragEnd
          }, null, 8, ["region", "regions", "customer", "row-index", "dragging-customer-id", "downstream-allocations", "downstream-tag-preferences", "syncing"]);
        }), 128))], 4);
      }), 128))])], 512)]))]);
    };
  }
};